import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import { uploadsUrl } from "../lib/uploader";
import { SectionHeading, Loading, EmptyState } from "../components/ui";

interface Perk {
  id: string;
  title: string;
  provider: string | null;
  thumbnailKey: string | null;
  publishedAt: string | null;
}

export function PerksPage() {
  const [items, setItems] = useState<Perk[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get<{ items: Perk[] }>("/perks")
      .then((r) => setItems(r.items))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-4">
      <div>
        <SectionHeading level={2}>会員特典</SectionHeading>
        <p className="text-sm text-tora-ink/60 mt-1">
          令和の虎 経営塾の塾生だけが受けられる特典です。カードをタップすると詳細が開きます。
        </p>
      </div>

      {loading ? (
        <Loading />
      ) : items.length === 0 ? (
        <EmptyState
          icon="🎁"
          title="現在ご案内できる特典はありません"
          description="特典が追加されるとここに表示されます。"
        />
      ) : (
        <ul className="space-y-3">
          {items.map((p) => {
            const thumb = uploadsUrl(p.thumbnailKey);
            return (
              <li key={p.id}>
                <Link
                  to={`/perks/${p.id}`}
                  className="card flex items-center gap-4 p-3 md:p-4 group hover:shadow-md transition-shadow"
                >
                  {thumb ? (
                    <img
                      src={thumb}
                      alt=""
                      className="w-24 h-20 md:w-28 md:h-24 shrink-0 object-cover rounded-lg border border-black/10 bg-black/5"
                    />
                  ) : (
                    <div className="w-24 h-20 md:w-28 md:h-24 shrink-0 rounded-lg border border-black/10 bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center text-3xl">
                      🎁
                    </div>
                  )}
                  <div className="flex-1 min-w-0">
                    <h3 className="text-base md:text-lg font-bold text-tora-ink leading-snug group-hover:text-tora transition-colors line-clamp-2">
                      {p.title}
                    </h3>
                    {p.provider && (
                      <p className="text-xs md:text-sm text-tora-ink/60 mt-1 truncate">
                        {p.provider}
                      </p>
                    )}
                  </div>
                  <span
                    className="shrink-0 text-tora-ink/30 group-hover:text-tora text-2xl leading-none transition-colors"
                    aria-hidden="true"
                  >
                    ›
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
